import * as actions from './documents.actions'

const initialState = {
  docs: [],
}

const actionsMap = {
  [actions.SET_DOCUMENTS]: (state, action) => {
    return {
      ...state,
      docs: action.data,
    }
  },
}

/* eslint require-jsdoc: 0 */
export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
